import React from 'react';
import CrearSilobolsa from '../../components/silobolsa/crearsilobolsa';
import { PageWrapper } from '../../components/common';

const CrearSilobolsaPage: React.FC = () => {
  return (
    <PageWrapper>
      <CrearSilobolsa />
    </PageWrapper>
  );
};

export default CrearSilobolsaPage;

